<div class="w-full flex flex-column align-items-center">

    <div class="w-8">

        <div *ngIf="isAutoRouted"
             class="bg-secondary p-4 text-center w-full text-white shadow-2 mb-6 border-round-lg flex flex-column align-items-center">
            <h2 class="text-gray-200">{{ 'sipo.payment-component.trial-end-title' | translate }}</h2>
            <p class="text-lg w-5" style="line-height: 1.6;">
                {{ 'sipo.payment-component.trial-end-message-part-1' | translate | uppercase }}
                <strong>{{ 'sipo.payment-component.sipo' | translate:{appName: appConfig.name} }}</strong> {{ 'sipo.payment-component.trial-end-message-part-2' | translate }}
            </p>
        </div>


        <p-steps [activeIndex]="activeStep" [model]="paymentSteps" styleClass="mb-6"/>

        <!--step-1 begin (only for subscription purchase)-->
        <ng-template [ngIf]="progressType === 'subscriptionPayment' && activeStep === 0">
            <app-plan-selection [isYearly]="isYearly"
                                [selectedPackage]="selectedPackage"
                                [isAutoRouted]="isAutoRouted"
                                [packages]="packages"
                                [userSubscription]="userSubscription"
                                (packageSelected)="packageSelected($event)">
            </app-plan-selection>
        </ng-template>
        <!--step-1 end (only for subscription purchase)-->

        <!--step-2 begin (only for subscription purchase)-->
        <ng-template [ngIf]="progressType === 'subscriptionPayment' && activeStep === 1">
            <app-plan-details
                [isYearly]="isYearly"
                [activeStep]="activeStep"
                [selectedPackage]="selectedPackage"
                (buySelectedPlan)="buySelectedPlan($event)">
            </app-plan-details>
        </ng-template>
        <!--step-2 end (only for subscription purchase)-->

        <!--step-1 begin (only for credit purchase)-->
        <ng-template [ngIf]="progressType === 'creditPayment' && activeStep === 0">
            <app-credit-selection (payCredit)="payCredit($event)"></app-credit-selection>
        </ng-template>
        <!--step-1 end (only for credit purchase)-->

        <!--step-3 begin-->
        <ng-template
            [ngIf]="(progressType === 'creditPayment' && activeStep === 1)">
            <app-pay [selectedPlan]="selectedPackage"
                     [isYearly]="isYearly"
                     [creditAmount]="selectedCreditAmount"
                     [progressType]="progressType"
                     (paymentState)="paymentResult($event)">
            </app-pay>
        </ng-template>
        <ng-template
            [ngIf]="(progressType === 'subscriptionPayment' && activeStep === 2)">
            <app-pay [selectedPlan]="selectedPackage"
                     [isYearly]="isYearly"
                     [progressType]="progressType"
                     (paymentState)="paymentResult($event)">
            </app-pay>

        </ng-template>
        <!--step-3 end-->

        <!--step-4 begin-->
        <ng-template
            [ngIf]="(progressType === 'creditPayment' && activeStep === 2) || (progressType === 'subscriptionPayment' && activeStep === 3)">
            <app-payment-result
                [processState]="processState"
                [progressType]="progressType">
            </app-payment-result>
        </ng-template>

        <!--step-4 end-->

    </div>
</div>
